import map from 'lodash/map'
import { ProductStatusEnum, ProductTypeEnum } from '@ztechapps/common.contract'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { useDieSetTypes, useDieShapes, useProductCategories } from '../useProductSpecification'

const statuses = map(ProductStatusEnum, (e) => e)
const productType = map(ProductTypeEnum, (e) => e)

export const useProductListFieldConfig = (): ListFieldConfig => {
  //build the fields for table
  const categories = useProductCategories()
  const dieShapes = useDieShapes()
  const dieSetTypes = useDieSetTypes()
  const categoryArray = map(categories, (e) => e.value)
  const dieShapeArray = map(dieShapes, (e) => e.value)
  const dieSetTypeArray = map(dieSetTypes, (e) => e.value)

  return {
    code: { name: 'code', displayName: 'Code', size: 250, index: 0 },
    name: { name: 'name', displayName: 'Name', size: 600, index: 1 },
    price: { name: 'price', displayName: 'Price', excludeOnSearch: true, type: ListFieldTypeEnum.number, index: 2 },
    quantityOnHand: {
      name: 'inventory.quantityOnHand',
      displayName: 'Qty. On Hand',
      size: 150,
      excludeOnSearch: true,
      index: 3,
      type: ListFieldTypeEnum.number,
    },
    computedQuantity: {
      name: 'requiredComputedQuantityOnHand',
      displayName: 'Computed Qty.',
      size: 150,
      excludeOnSearch: true,
      excludeOnSort: true,
      excludeOnFilter: true,
      type: ListFieldTypeEnum.number,
      index: 4,
    },
    status: {
      name: 'status',
      displayName: 'Status',
      type: ListFieldTypeEnum.select,
      fieldSettings: {
        listValues: statuses,
      },
      index: 5,
      size: 150,
    },
    remarks: { name: 'remarks', size: 300 },
    tags: { name: 'tags', excludeOnSort: true, size: 200 },
    _id: { name: '_id', isVisible: false },
    serialNumber: {
      name: 'inventorybyserialnumbers.code',
      excludeOnSort: true,
      displayName: 'Serial number',
      isVisible: false,
      excludeOnDisplay: true,
    },
    requiredSerialNumber: {
      name: 'requiredSerialNumber',
      excludeOnSort: true,
      displayName: 'Required Serial Number?',
      isVisible: false,
      type: ListFieldTypeEnum.boolean,
      excludeOnDisplay: true,
      excludeOnSearch: true,
    },
    batchCode: {
      name: 'inventorybyserialnumbers.batchCode',
      excludeOnSort: true,
      displayName: 'Reference code',
      isVisible: false,
      excludeOnDisplay: true,
    },
    coverImage: {
      name: 'coverImage',
      displayName: 'Image',
      excludeOnSort: true,
      excludeOnSearch: true,
      excludeOnFilter: true,
      isVisible: false,
    },
    forSale: {
      name: 'forSale',
      displayName: 'For Sale',
      excludeOnSearch: true,
      excludeOnSort: true,
      type: ListFieldTypeEnum.boolean,
      isVisible: false,
    },
    productType: {
      name: 'productType',
      displayName: 'Type',
      size: 200,
      isVisible: false,
      type: ListFieldTypeEnum.select,
      fieldSettings: {
        listValues: productType,
      },
    },
    category: {
      name: 'metadataObject.category',
      displayName: 'Category',
      size: 200,
      isVisible: false,
      type: ListFieldTypeEnum.select,
      fieldSettings: {
        listValues: categoryArray,
      },
      excludeOnSearch: true,
    },
    dieSetType: {
      name: 'metadataObject.dieSetType',
      displayName: 'Die Set Type',
      size: 200,
      isVisible: false,
      type: ListFieldTypeEnum.select,
      fieldSettings: {
        listValues: dieSetTypeArray,
      },
      excludeOnSearch: true,
    },
    dieShape: {
      name: 'metadataObject.shape',
      displayName: 'Die Set Shape',
      size: 200,
      isVisible: false,
      type: ListFieldTypeEnum.select,
      fieldSettings: {
        listValues: dieShapeArray,
      },
      excludeOnSearch: true,
    },
    horizontalIn: {
      name: 'metadataObject.horizontalIn',
      displayName: 'Horizontal (Inches)',
      type: ListFieldTypeEnum.number,
      size: 200,
      isVisible: false,
      excludeOnSearch: true,
    },
    horizontalMm: {
      name: 'metadataObject.horizontalMm',
      displayName: 'Horizontal (Mm)',
      type: ListFieldTypeEnum.number,
      size: 200,
      isVisible: false,
      excludeOnSearch: true,
    },
    verticalIn: {
      name: 'metadataObject.verticalIn',
      displayName: 'Vertical (Inches)',
      type: ListFieldTypeEnum.number,
      size: 200,
      isVisible: false,
      excludeOnSearch: true,
    },
    verticalMm: {
      name: 'metadataObject.verticalMm',
      displayName: 'Vertical (Mm)',
      type: ListFieldTypeEnum.number,
      size: 200,
      isVisible: false,
      excludeOnSearch: true,
    },
    weightPounds: {
      name: 'metadataObject.weightPounds',
      displayName: 'Weight (Pounds)',
      type: ListFieldTypeEnum.number,
      size: 200,
      isVisible: false,
      excludeOnSearch: true,
    },
    shippingWeight: {
      name: 'metadataObject.shippingWeight',
      displayName: 'Shipping Weight',
      type: ListFieldTypeEnum.number,
      size: 200,
      isVisible: false,
      excludeOnSearch: true,
    },
  }
}
